import { Link } from 'react-router-dom';

const filterSelect =
  'rounded-full border border-evault-select-ring/70 bg-white px-3 py-2 text-xs text-umb-neutral-dark shadow-sm focus:border-evault-teal focus:outline-none focus:ring-2 focus:ring-evault-teal/20 sm:text-sm';

const issueReceiptBtn =
  'rounded-full bg-evault-teal-deep px-3 py-1.5 text-[11px] font-semibold text-white shadow-sm hover:bg-evault-teal-hover focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-evault-teal/35 disabled:cursor-not-allowed disabled:opacity-45';

/** PDF §6 Pledge Queue — prerequisites, supporting materials, pledge receipt */
const rows = [
  {
    id: 'pl-2201',
    asset: 'A-18788',
    facility: 'UMB Line A',
    prerequisites: 'Lien search · OK',
    supporting:
      'UCC-1 PDF, authorization memo, collateral schedule v3',
    state: 'Ready to execute',
    receipt: 'Pending',
  },
  {
    id: 'pl-2198',
    asset: 'A-18802',
    facility: 'UMB Line A',
    prerequisites: 'UCC filing proof',
    supporting: 'Filing receipt pending from originator',
    state: 'Pending decision',
    receipt: '—',
  },
];

export function PledgeQueuePage() {
  return (
    <div className="page-stack">
      <section className="card-shell p-5 sm:p-6">
        <p className="text-sm leading-relaxed text-evault-muted">
          Execution surface for pledge events: prerequisites, supporting
          materials, and issuance of the resulting custody receipt.
        </p>
        <div className="mt-4 flex flex-wrap gap-2">
          <select className={filterSelect} defaultValue="All states">
            <option>All states</option>
            <option>Pending decision</option>
            <option>Ready to execute</option>
            <option>Executed</option>
            <option>Packaging</option>
          </select>
        </div>
      </section>

      <div className="table-shell overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full min-w-[920px] border-collapse text-left text-xs sm:text-sm">
            <thead>
              <tr className="border-b border-evault-border bg-evault-surface/90">
                <th className="px-4 py-3 font-semibold text-evault-muted">
                  Pledge ref
                </th>
                <th className="px-4 py-3 font-semibold text-evault-muted">
                  Asset
                </th>
                <th className="px-4 py-3 font-semibold text-evault-muted">
                  Facility
                </th>
                <th className="px-4 py-3 font-semibold text-evault-muted">
                  Prerequisites
                </th>
                <th className="px-4 py-3 font-semibold text-evault-muted">
                  Supporting materials
                </th>
                <th className="px-4 py-3 font-semibold text-evault-muted">
                  Action state
                </th>
                <th className="px-4 py-3 font-semibold text-evault-muted">
                  Receipt
                </th>
                <th className="px-4 py-3 font-semibold text-evault-muted">
                  Issue receipt
                </th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row, ri) => (
                <tr
                  key={row.id}
                  className={`border-b border-evault-border last:border-b-0 ${
                    ri % 2 === 1 ? 'bg-evault-surface/40' : ''
                  }`}
                >
                  <td className="px-4 py-3.5 font-medium text-evault-teal">
                    {row.id}
                  </td>
                  <td className="px-4 py-3.5">
                    <Link
                      to={`/custodian/assets/${encodeURIComponent(row.asset)}`}
                      className="font-mono text-[11px] hover:underline sm:text-xs"
                    >
                      {row.asset}
                    </Link>
                  </td>
                  <td className="px-4 py-3.5 text-umb-neutral-dark/85">
                    {row.facility}
                  </td>
                  <td className="px-4 py-3.5 text-umb-neutral-dark/85">
                    {row.prerequisites}
                  </td>
                  <td className="max-w-[200px] px-4 py-3.5 text-umb-neutral-dark/80">
                    {row.supporting}
                  </td>
                  <td className="px-4 py-3.5 font-medium text-evault-teal-deep">
                    {row.state}
                  </td>
                  <td className="px-4 py-3.5 text-umb-neutral-dark/80">
                    {row.receipt}
                  </td>
                  <td className="px-4 py-3.5">
                    <button
                      type="button"
                      className={issueReceiptBtn}
                      disabled={row.state !== 'Ready to execute'}
                      title={
                        row.state !== 'Ready to execute'
                          ? 'Complete prerequisites first'
                          : 'Generate pledge custody receipt'
                      }
                    >
                      Issue receipt
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
